import { render } from "./newPosts.vue?vue&type=template&id=d3b8e936"
import script from "./newPosts.vue?vue&type=script&lang=js"
export * from "./newPosts.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__